import { render, staticRenderFns } from "./CategoryLabel.vue?vue&type=template&id=526df75a"
import script from "./CategoryLabel.vue?vue&type=script&lang=js"
export * from "./CategoryLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports